/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { polarisSettingsGlobalFieldsRoute } from '@jira/router-routes__polaris-routes/src/polarisSettingsGlobalFieldsRoute.tsx';
import { polarisProductGlobalFieldsSettingsPageEntryPoint } from './ui/settings/global-fields/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisSettingsGlobalFieldsRouteEntry: Route = createEntry(
	polarisSettingsGlobalFieldsRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		entryPoint() {
			return polarisProductGlobalFieldsSettingsPageEntryPoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
